// we need to import all widgets from insite/content-library/Widgets/OrderHistory/
import orderHistoryHeader from "@insite/content-library/Widgets/OrderHistory/OrderHistoryHeader";
import orderHistoryPagination from "@insite/content-library/Widgets/OrderHistory/OrderHistoryPagination";
import orderHistoryResultCount from "@insite/content-library/Widgets/OrderHistory/OrderHistoryResultCount";
import orderHistorySearchClearButton from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchClearButton";
import orderHistorySearchField from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchField";
import orderHistorySearchFieldDateRange from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import orderHistorySearchFieldOrderNumber from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldOrderNumber";
import orderHistorySearchFieldOrderTotal from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldOrderTotal";
import orderHistorySearchFieldOrderTotalOperator from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldOrderTotalOperator";
import orderHistorySearchFieldPoNumber from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldPoNumber";
import orderHistorySearchFieldProductErpNumber from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldProductErpNumber";
import orderHistorySearchFieldProductErpNumber2 from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldProductErpNumber2";
import orderHistorySearchFieldShipTos from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldShipTos";
import orderHistorySearchFieldShowMyOrders from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldShowMyOrders";
import orderHistorySearchFieldStatus from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldStatus";
import orderHistorySearchFieldVmiLocation from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldVmiLocation";
import orderHistorySearchForm from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm";
import orderHistorySearchTags from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags";
import orderHistoryTable, {
    orderHistoryTableStyles as styles,
} from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import { css } from "styled-components";

orderHistoryHeader.definition.allowedContexts = [
    ...(orderHistoryHeader.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistoryPagination.definition.allowedContexts = [
    ...(orderHistoryPagination.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistoryResultCount.definition.allowedContexts = [
    ...(orderHistoryResultCount.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchClearButton.definition.allowedContexts = [
    ...(orderHistorySearchClearButton.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchField.definition.allowedContexts = [
    ...(orderHistorySearchField.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldDateRange.definition.allowedContexts = [
    ...(orderHistorySearchFieldDateRange.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldOrderNumber.definition.allowedContexts = [
    ...(orderHistorySearchFieldOrderNumber.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldOrderTotal.definition.allowedContexts = [
    ...(orderHistorySearchFieldOrderTotal.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldOrderTotalOperator.definition.allowedContexts = [
    ...(orderHistorySearchFieldOrderTotalOperator.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldPoNumber.definition.allowedContexts = [
    ...(orderHistorySearchFieldPoNumber.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldProductErpNumber.definition.allowedContexts = [
    ...(orderHistorySearchFieldProductErpNumber.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldProductErpNumber2.definition.allowedContexts = [
    ...(orderHistorySearchFieldProductErpNumber2.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldShipTos.definition.allowedContexts = [
    ...(orderHistorySearchFieldShipTos.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldShowMyOrders.definition.allowedContexts = [
    ...(orderHistorySearchFieldShowMyOrders.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldStatus.definition.allowedContexts = [
    ...(orderHistorySearchFieldStatus.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchFieldVmiLocation.definition.allowedContexts = [
    ...(orderHistorySearchFieldVmiLocation.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchForm.definition.allowedContexts = [
    ...(orderHistorySearchForm.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistorySearchTags.definition.allowedContexts = [
    ...(orderHistorySearchTags.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];
orderHistoryTable.definition.allowedContexts = [
    ...(orderHistoryTable.definition?.allowedContexts ?? []),
    "AirOrdersHistoryPage" as any,
];

styles.container = {
    ...styles.container,
    css: css`
        overflow: auto;
        & .orders-view__actions-btn {
            appearance: none !important;
        }
    `,
};
